import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import {
  NotebookPage,
  NotebookPageApiModel,
  NotebookPageSpotlight,
} from "@/modules/notebook-editor/types";

const fetchNotebookPage = async (uuid: string): Promise<ApiResponse<NotebookPage>> => {
  return await httpClient.get(`/apis/notebook-page/get/${uuid}`);
};

const createNotebookPage = async (
  notebookPage: NotebookPageApiModel,
): Promise<ApiResponse<NotebookPage>> => {
  return await httpClient.post(`/apis/notebook-page/create`, notebookPage);
};

const updateNotebookPage = async (
  notebookPage: NotebookPage,
): Promise<ApiResponse<NotebookPage>> => {
  return await httpClient.post(`/apis/notebook-page/update/${notebookPage.uuid}`, notebookPage);
};

const deleteNotebookPage = async (uuid: string): Promise<ApiResponse<void>> => {
  return await httpClient.post(`/apis/notebook-page/delete/${uuid}`);
};

const reorderNotebookPage = async (
  pageUuid: string,
  pageOrder: string,
): Promise<ApiResponse<void>> => {
  const data = new URLSearchParams();
  data.append("pageOrder", pageOrder);
  return await httpClient.post(`/apis/notebook-page/reorder/${pageUuid}?${data}`);
};

const updateNotebookPageSpotlight = async (
  pageUuid: string,
  spotlightColor: string,
): Promise<ApiResponse<NotebookPage>> => {
  return await httpClient.post(
    `/apis/notebook-page/spotlight/update/${pageUuid}`,
    JSON.stringify(spotlightColor),
  );
};

const deleteNotebookPageSpotlight = async (
  pageUuid: string,
): Promise<ApiResponse<NotebookPageSpotlight>> => {
  return await httpClient.post(`/apis/notebook-page/spotlight/delete/${pageUuid}`);
};

export default {
  fetchNotebookPage,
  createNotebookPage,
  updateNotebookPage,
  deleteNotebookPage,
  reorderNotebookPage,
  updateNotebookPageSpotlight,
  deleteNotebookPageSpotlight,
};
